class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => { this.classList.add('animate', 'active') });

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);


//Coupon Code
class PromoCodeSection extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.target.classList.contains('cart-coupon-main') ? this.querySelector('.promo-code-wrap').classList.toggle('open') : null;
  
    });
  }
}
customElements.define('promo-code-wrap', PromoCodeSection);


class CartCouponCodeButton extends HTMLElement {
  constructor() {
    super();
    let current_form = this;
    this.querySelector('#coupon-form').addEventListener('submit', (event) => {

      event.preventDefault();
      this.submitForm(current_form.querySelector('.promo-input.couponCode').value)
    });
  }
 

  applyCouponCode(discountCode) {
    return new Promise((resolve, reject) => {
      let discountApplyUrl = "https://" + window.location.host + "/discount/" + discountCode;

      // Create a hidden iframe to apply discount using the checkout session
      let i = document.createElement('iframe');
      i.style.display = 'none';
      
      // Remove the iframe after it loads
      i.onload = function() {
          i.parentNode.removeChild(i);
          resolve(); // Resolve the promise when the discount is applied successfully
      };

      // If there's an error, reject the promise
      i.onerror = function() {
          i.parentNode.removeChild(i);
          reject(new Error("Failed to apply discount code."));
      };

      i.src = discountApplyUrl;
      document.body.appendChild(i);
  });
  }
  submitForm(discountCode){
    let current_this = this
    current_this.applyCouponCode(discountCode)
    .then(() => {
        console.log("Discount applied successfully!");
        fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
        .then((response) => response.json())
        .then((response) => {
            let responseFormated = {
                sections: response
            }
            let cart_drawer = document.querySelector('cart-drawer');
            cart_drawer.renderContents(responseFormated)
        })
      })
    .catch(error => {
        console.error("Error applying discount:", error.message);
    });
  }
}
customElements.define('cart-coupon-form', CartCouponCodeButton);

// This js is cart drawer Free product, upsell product and free gift card
// Shared accordion logic with localStorage
window.addEventListener("beforeunload", () => {
  localStorage.removeItem("accordionOpenId");
});

document.addEventListener("DOMContentLoaded", () => {
  const firstHiddenList = document.querySelector("ul.products_list.hidden");
  const savedId = localStorage.getItem("accordionOpenId");
  
  // console.log(firstHiddenList);
  // if (firstHiddenList) {
  //   firstHiddenList.classList.remove("hidden");
  // }
});

function initAccordionWithStorage(groupKey = "accordion") {
  const buttons = document.querySelectorAll(".upsell-accordin-button, .giftwrap-accordin-button");
  const savedId = localStorage.getItem("accordionOpenId");

  buttons.forEach((button) => {
    const list = button.nextElementSibling;
    const id = button.getAttribute("data-accordion-id");

    if (!id) return;

    // Restore saved accordion state
    if (savedId === id && list) {
      list.classList.remove("hidden");
    }

    // 🔹 Remove any existing event listeners first
    button.replaceWith(button.cloneNode(true));
  });

  // Re-select buttons after cloning (old ones removed)
  document.querySelectorAll(".upsell-accordin-button, .giftwrap-accordin-button").forEach((button) => {
    const list = button.nextElementSibling;
    const id = button.getAttribute("data-accordion-id");

    button.addEventListener("click", function () {
      const isOpen = list && !list.classList.contains("hidden");
      document.querySelectorAll(".products_list").forEach((el) => el.classList.add("hidden"));
      if (!isOpen && list) {
        list.classList.remove("hidden");
        localStorage.setItem("accordionOpenId", id);
      } else {
        localStorage.removeItem("accordionOpenId");
      }
    });
  });
}



// -------- CartDrawerUpsell ----------
class CartDrawerUpsell extends HTMLElement {
  constructor() {
    super();
    initAccordionWithStorage("accordion-upsell");
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);

// -------- CartFreeProducts ----------
class CartFreeProducts extends HTMLElement {
  constructor() {
    super();
    initAccordionWithStorage("accordion-freeproducts");
    this.init();

    this.querySelectorAll(".show_more").forEach((e) => {
      e.addEventListener("click", (button) => {
        let btn = button.target;
        btn.closest(".product_info").querySelector(".product_description").classList.toggle("show");
        btn.closest(".show_more").classList.toggle("show");
        console.log(btn,"btn")
      })
    })
    
  }

  async init() {
    // await this.autoSelectFirstThreeIfNoneChecked();
    this.initCheckboxListeners();
  }

  // async autoSelectFirstThreeIfNoneChecked() {
  //   const checkedCheckboxes = this.querySelectorAll("input[type='checkbox']:checked");
  //   if (checkedCheckboxes.length === 0) {
  //     const checkboxes = this.querySelectorAll("input[type='checkbox']");
  //     let selectedCount = 0;
  //     for (const checkbox of checkboxes) {
  //       if (selectedCount < 3 && !checkbox.checked) {
  //         checkbox.checked = true;
  //         checkbox.setAttribute("disabled", "");
  //         const variantId = Number(checkbox.getAttribute("data-variant-id"));
  //         await this.addToCart(variantId);
  //         selectedCount++;
  //       }
  //     }
  //     checkboxes.forEach((checkbox) => {
  //       if (!checkbox.checked) {
  //         checkbox.setAttribute("disabled", "");
  //       }
  //     });
  //   }
  // }

  initCheckboxListeners() {
    this.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
      checkbox.addEventListener("change", async (event) => {
        const allCheckboxes = this.querySelectorAll("input[type='checkbox']");
        const checkedCheckboxes = this.querySelectorAll("input[type='checkbox']:checked");
        const newVariantId = Number(event.target.getAttribute("data-variant-id"));

        // Find footer
        const footer = document.querySelector(".cart-drawer__footer");
        if (!footer) return;

        // Remove old error if exists
        const existingError = footer.querySelector(".sample-error");
        if (existingError) existingError.remove();

        if (event.target.checked) {
          if (checkedCheckboxes.length > 3) {
            event.target.checked = false;

            // Add error message
            const errorMsg = document.createElement("div");
            errorMsg.className = "sample-error-msg";
            errorMsg.textContent = "לא ניתן לבחור יותר מ3 דוגמיות";
            footer.appendChild(errorMsg);

            return;
          }
          await this.addToCart(newVariantId);
        } else {
          await this.removeFromCart(newVariantId);
        }

        // Enable/disable checkboxes
        if (this.querySelectorAll("input[type='checkbox']:checked").length < 3) {
          allCheckboxes.forEach((cb) => {
            if (!cb.checked) cb.removeAttribute("disabled");
          });
        } else {
          allCheckboxes.forEach((cb) => {
            if (!cb.checked) cb.setAttribute("disabled", "");
          });
        }
      });
    });
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity,
          properties: { sample: "free" },
        }),
      });

      if (!response.ok) throw new Error("Add to cart failed");

      const sectionRes = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      const sectionData = await sectionRes.json();
      const cart_drawer = document.querySelector("cart-drawer");
      if (cart_drawer && typeof cart_drawer.renderContents === "function") {
        cart_drawer.renderContents({ sections: sectionData });
      }
    } catch (err) {
      console.error("Error adding to cart:", err);
    }
  }

  async removeFromCart(variantId) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: `${variantId}`, quantity: 0 }),
      });

      if (!response.ok) throw new Error("Remove from cart failed");

      const sectionRes = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
      const sectionData = await sectionRes.json();
      const cart_drawer = document.querySelector("cart-drawer");
      if (cart_drawer && typeof cart_drawer.renderContents === "function") {
        cart_drawer.renderContents({ sections: sectionData });
      }

      console.log("Gift product removed:", variantId);
    } catch (err) {
      console.error("Error removing from cart:", err);
    }
  }
}
customElements.define("cart-free-products", CartFreeProducts);

// -------- CartGiftWrap ----------
class CartGiftWrap extends HTMLElement {
  constructor() {
    super();
    initAccordionWithStorage("accordion-giftwrap");
    this.autoSelectFreeGiftWrap();
    this.initRadioListeners();
  }

  async autoSelectFreeGiftWrap() {
    const giftVariants = [...this.querySelectorAll("input[type='radio']")].map(radio => +radio.dataset.variantId);
    const existingVariant = await this.checkVariantInCart(giftVariants);
    if (existingVariant) return;

    const radios = this.querySelectorAll("input[type='radio']");
    const firstRadio = radios[0];

    // if (firstRadio) {
    //   firstRadio.checked = true;
    //   const newVariantId = Number(firstRadio.getAttribute("data-variant-id"));
    //   this.addToCart(newVariantId);
    // }
  }

  initRadioListeners() {
    this.querySelectorAll("input[type='radio']").forEach((radio) => {
      radio.addEventListener("change", async () => {
        const selectedRadio = this.querySelector("input[type='radio']:checked");
        const newVariantId = Number(selectedRadio.getAttribute("data-variant-id"));
        const giftVariants = [...this.querySelectorAll("input[type='radio']")].map(e => +e.dataset.variantId);

        const existingVariant = await this.checkVariantInCart(giftVariants);
        if (existingVariant) {
          await this.removeFromCart(existingVariant, newVariantId);
        } else {
          await this.addToCart(newVariantId);
        }
      });
    });
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity }),
      });
      const data = await response.json();
      await this.refreshCartSections();
      console.log("Product added to cart:", data);
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }

  async removeFromCart(variantId, newVariantId) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: `${variantId}`, quantity: 0 }),
      });
      const data = await response.json();
      await this.addToCart(newVariantId);
      await this.refreshCartSections();
      console.log("Previous gift wrap removed:", data);
    } catch (error) {
      console.error("Error removing from cart:", error);
    }
  }

  async refreshCartSections() {
    const response = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
    const sectionData = await response.json();
    const cart_drawer = document.querySelector("cart-drawer");
    if (cart_drawer && typeof cart_drawer.renderContents === "function") {
      cart_drawer.renderContents({ sections: sectionData });
    }
  }

  async checkVariantInCart(giftVariants) {
    const response = await fetch(`${routes.cart_url}.json`);
    const data = await response.json();
    const cartItems = data.items.map(item => +item.variant_id);
    return giftVariants.find(v => cartItems.includes(v)) || false;
  }
}
customElements.define("cart-gift-wrap", CartGiftWrap);


// clubmember-message js starts from here

document.addEventListener('DOMContentLoaded', function () {
    if(document.querySelector(".cart-club-login")){
      document.body.addEventListener("click", (e) => {
        if(e.target.classList.contains("ragister-main")){
          e.preventDefault();
          document.querySelector('register-modal').openModal(e.target)
        }
        if(e.target.classList.contains("login-main")){
          e.preventDefault();
          document.querySelector('login-modal').openModal(e.target);
        }
      })
    }
    if(document.querySelector(".club-member-product")){
       document.body.addEventListener("click", (e) => {
        if(e.target.classList.contains("club-member-product")){
          document.querySelector(".club-member-popup-main").style.display = "flex";
          // let varID = Number(e.target.value);
          // console.log("varID",varID)
          // addToCartmain(varID)
        }
       })
    }
    function addToCartmain(variantId, quantity = 1) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Add to cart failed");
          }
          return fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`);
        })
        .then((sectionRes) => sectionRes.json())
        .then((sectionData) => {
          const cart_drawer = document.querySelector("cart-drawer");
          if (cart_drawer && typeof cart_drawer.renderContents === "function") {
            cart_drawer.renderContents({ sections: sectionData });
          }
        })
        .catch((err) => {
          console.error("Error adding to cart:", err);
        });
    }
});